export const SEND_CONTACT_FORM = 'app/send_contact_form'
